import React, { useEffect, useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Login.css";
// Necesitarás instalar estos iconos: npm install react-icons
import { FaEnvelope, FaLock } from "react-icons/fa";

const APIHOSTNAME = "https://mixta39.dev/phpapi/api";
const API_URL = `${APIHOSTNAME}/login.php`;
const API_URL_SESSION = `${APIHOSTNAME}/verifySession.php`;

const Login = () => {
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const checkSession = async () => {
            const userString = localStorage.getItem("user");

            if (userString) {
                try {
                    const user = JSON.parse(userString);
                    console.log("El usuario ya esta autenticado:", user);

                    const response = await axios.get(API_URL_SESSION, {
                        headers: {
                            Authorization: `Bearer ${user.token}`,
                        },
                    });
                    console.log(response.data);

                    navigate("/"); // Redirige si la sesión es válida
                } catch (error) {
                    console.error("Error al verificar la sesión:", error);
                    localStorage.removeItem("user");
                    navigate("/login");
                }
            }
        };

        checkSession();
    }, [navigate]);

    const handleGoogleLogin = async (response) => {
        setLoading(true);
        setError("");

        try {
            const res = await axios.post(API_URL, { credential: response.credential });

            if (res.data.success) {
                localStorage.setItem("user", JSON.stringify(res.data.user));
                navigate("/", { replace: true });
            } else {
                setError(res.data.error || "Error desconocido en el login con Google.");
            }
        } catch (error) {
            console.error("Error en el login con Google:", error);
            setError("Hubo un error en el inicio de sesión con Google.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="card-login">
                <div className="login-form">
                    <h2>¡Bienvenido!</h2>
                    <p>Inicia sesión para acceder a tu cuenta</p>

                    {error && <div className="alert-danger">{error}</div>}

                    <div className="social-login">
                        <div className="google-login-wrapper">
                            <GoogleLogin
                                onSuccess={handleGoogleLogin}
                                onError={() => setError("Error en el inicio de sesión con Google")}
                            />
                        </div>
                    </div>
                    <br />
                    <div className="form-input">
                        <i><FaEnvelope /></i>
                        <input type="email" placeholder="Correo electrónico" disabled />
                    </div>
                    <div className="form-input">
                        <i><FaLock /></i>
                        <input type="password" placeholder="Contraseña" disabled />
                    </div>

                    <button className="btn-primary-login" >INICIAR SESIÓN</button>
                    
                    {loading && <p className="loading-spinner">Cargando...</p>}
                </div>
            </div>
        </div>
    );
};

export default Login;
